<template>
    <div class="standard sidebar">
        <div class="ui secondary vertical menu"
            data-step="1"
            data-position='right'
            data-intro="<br> 歡迎使用Neuron物流系統 <br> 選擇功能 開始編輯">
            <nav style="margin: 8px 0;">
                <router-link v-if="$store.state.initialize_statuses.service_theme" :to="{name: 'provider_index'}">
                    <img class="ui image"
                        :src="'/images/'+service_config.logo_img">
                </router-link>
                <div v-else class="ui inverted dimmer transition active">
                    <div class="ui tiny text loader">
                        {{ $t('ui.general.initializing') }}
                    </div>
                </div>

                <a class="hamburger hamburger--spin"
                    @click="toggle_menu()">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </a>
            </nav>
            <div class="nav-menu z-depth-1" style="margin-left: 15px;border: 5px solid #7cc950;background-color: white;">
                <div class="station-selector z-depth-1 ui dropdown no_search" v-dropdown>
                    <span v-if="current_station.name">
                        {{ current_station.name }}
                    </span>
                    <span v-else>
                        總站點
                    </span>
                    <span v-if="current_station.code">
                        ({{ current_station.code }})
                    </span>
                    <div class="menu" style="width: 100%;border: 5px solid rgb(124, 201, 80);border-radius: 0;">
                        <div class="item"
                            v-if="!current_staff.station_identity"
                            @click.prevent="update_staff_and_current_station(null)"
                            :class="{
                                'selected active': current_station.identity == null
                            }">
                            <!-- 取消當前站點 -->
                            <i class="warehouse icon"></i>
                            總站點
                        </div>
                        <a class="item"
                            v-for="station in selectable_stations"
                            :key="station.identity"
                            :class="{'ui dropdown': station.child_stations.length > 0}">
                            <i class="warehouse icon"></i>
                            <a @click="update_staff_and_current_station(station)" style="color: black;">
                                {{ station.name }}
                            </a>
                            <i class="dropdown icon" v-if="station.child_stations.length > 0" style="top: -5px;"></i>
                            <div class="menu" v-if="station.child_stations.length > 0">
                                <a class="item"
                                    v-for="child_station in station.child_stations"
                                    :key="child_station.identity"
                                    @click="update_staff_and_current_station(child_station)">
                                    {{ child_station.name }}
                                </a>
                            </div>
                        </a>
                    </div>
                </div>

                <SidebarItem
                    v-for="service_config_menu in $store.state.provider.service_config.menu"
                    :service_config_menu="service_config_menu"
                    :key="service_config_menu.name"
                    >
                </SidebarItem>

                <!-- <hr> -->

                <!-- <div v-for="menu in menus" :key="menu.name">

                    <router-link class="item"
                        v-if="!menu.items"
                        :to="{name: $store.state.initialize_statuses.sidebar ? menu.name:null}">
                        <i class="icons">
                            <i v-if="menu.icon" :class="menu.icon+' icon'"></i>
                            <span> {{ $t('ui.links.menu.'+menu.name) }} </span>
                        </i>
                    </router-link>

                </div>
                <router-link class="item" :to="{name: 'provider_demo'}" v-if="env == 'development'">
                    <i class="icons">
                        <i class="help icon"></i>
                        <span>Demo</span>
                    </i>
                </router-link> -->
            </div>

        </div>
    </div>
</template>

<script>
import SidebarItem from '@partials/provider/sidebar_item.vue'

export default {
    data() {
        return {
            menus: this.diff_service_config_menu(),
            is_show_mobile_menu: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider
        },
        service_config() {
            return this.$store.state.provider.service_config
        },
        current_station() {
            return this.$store.getters['provider/current_station']
        },
        current_staff() {
            return this.current_store.current_staff
        },
        stations() {
            return this.current_store.stations
        },
        parent_stations() {
            return _.filter(this.stations, e => {
                return !e.parent_station
            })
        },
        selectable_stations () {
            if(this.current_staff.current_station.identity) {
                return _.filter(this.parent_stations, parent_station => {
                    return parent_station.identity == this.current_staff.current_station_identity
                })
            } else {
                return this.parent_stations;
            }
        },
        env() {
            return ENV.NODE_ENV
        },
    },
    watch: {
        '$route'(to, from) {
            if (
                (767 > $(window).width()) &&
                ($(".nav-menu").css("display") == "block")
            ) {
                this.toggle_menu()
            }
        },
    },
    mounted() {
        $(window).resize(() => {
            var wdth = $(window).width()
            var nav_menu_display = $(".nav-menu").css("display")
            if (nav_menu_display == 'none' && wdth > 767) {
                $(".nav-menu").css("display", "block")
            }
        })
    },
    methods: {
        // select_station() {
        //     var current_staff = this.$store.getters['provider/current_staff'];
        //     if((!current_staff.station_identity || !current_staff.station.parent_station_identity) && current_staff.identity) {
        //         this.$bus.$emit('toggle_station_modal', 'show');
        //     } else {
        //         this.$noty.error("您沒有切換站點的權限");
        //     }
        // },
        update_staff_and_current_station(new_station) {
            this.$store.commit('provider/set_current_staff_station', new_station)
            this.$noty.success(
                this.$t('ui.notifications.success.update__name', {
                    name: this.$t('models.stations')
                })
            )
            this.$bus.$emit('toggle_station_modal', 'hide');
        },
        diff_service_config_menu() {
            var service_config_menu = $.extend(true, [], this.$store.state.provider.service_config.menu)
            var result

            _.forEach(service_config_menu, (config_menu, index) => {
                result = _.findIndex(this.$store.state.provider.theme_menu, (menu) => {
                    return config_menu.name == menu
                })


                if (result < 0 && config_menu.items == undefined) {
                    delete service_config_menu[index]
                }


                // 還有子項目
                if (config_menu.items != undefined) {
                    _.forEach(config_menu.items, (item, item_index) => {
                        result = _.findIndex(this.$store.state.provider.theme_menu, (menu) => {
                            return item.name == menu
                        })

                        if (result < 0) {
                            delete service_config_menu[index].items[item_index]
                        }
                    })
                    _.remove(service_config_menu[index].items, _.isUndefined)

                }
            })

            // 整理子項目
            _.remove(service_config_menu, _.isUndefined)
            _.forEach(service_config_menu, (config_menu, index) => {
                var length = (config_menu.items) ? config_menu.items.length : 1
                if (!length) {
                    delete service_config_menu[index];
                }
            })
            _.remove(service_config_menu, _.isUndefined)

            return service_config_menu
        },
        toggle_menu() {
            $("body").toggleClass("overflow")
            $(".hamburger").toggleClass("active")
            $(".nav-menu").stop().slideToggle(300)
            this.is_show_mobile_menu = !this.is_show_mobile_menu
            this.$bus.$emit('toggle_is_hide_icon_toggle_scanner_modal', this.is_show_mobile_menu)
        },
    },
    components: {
        SidebarItem,
    },
}
</script>

<style>
.station-selector {
    display: block !important;
    margin: 10px;
    background-color: #7cc950;
    padding: 15px 10px;
    border-radius: 0;
    text-align: center !important;
    font-size: 16px;
    font-weight: bold;
    color: white;
    text-shadow: 0px 0px 5px #a0a0a0;
    cursor: pointer;
}
</style>
<style lang="scss">
    @import "../../../assets/stylesheets/sidebar.scss";
</style>
